<template>
  <d-modal
    :key="'popup-medical-' + isVisible"
    :class="{ 'popup-form': true, 'is-hidden': !isVisible }"
    @close="onClosePopup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja badania</template>
          <template v-else>Dodawania badania</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer
        ref="medical-examinations-patients-form"
        tag="form">
        <div
          class="form-group">
          <label for="institution_id">
            Przypisana placówka:
          </label>
          <validation-provider
            rules="required"
            name="institution_id"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="allInstitutions"
                v-model="data.institution_id"
                :reduce="institution => institution.id"
                placeholder="Wybierz placówkę"
                name="institution_id"
                label="name">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name }}
                  </div>
                </template>
                <template slot="no-options">
                  Brak pasujących rezultatów
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div
          v-if="!visitId"
          class="form-group">
          <label for="visit">
            Data wizyty:
          </label>
          <validation-provider
            rules="required"
            name="visit"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                :options="patient.visits_history"
                v-model="data.visit_id"
                :reduce="visit => visit.id"
                placeholder="Wybierz wizytę"
                label="id">
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.date_start }} - {{ option.date_end }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.date_start }} - {{ option.date_end }}
                  </div>
                </template>
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="medical">
            Badanie lekarskie:
          </label>
          <validation-provider
            rules="required"
            name="medical"
            v-slot="{ errors }">
            <div
              :class="{
                'form-control': true,
                'is-select': true,
                'is-invalid': errors.length
              }">
              <v-select
                v-model="data.medical_examination_id"
                :options="medicalExaminations"
                :reduce="medical => medical.id"
                :state="errors.length ? 'invalid' : null"
                :disabled="isEdit"
                label="name"
                name="medical"
                placeholder="Wyszukaj badanie..." >
              </v-select>
            </div>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="short_description">
            Krótka notatka:
          </label>
          <validation-provider
            name="short_description"
            v-slot="{ errors }">
            <d-input
              :state="errors.length ? 'invalid' : null"
              v-model="data.short_description" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <d-row>
          <d-col cols="12" md="6" lg="6">
            <label for="filename">
              Nazwa dokumentu:
            </label>
            <validation-provider
              name="filename"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="data.scan_file.name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </d-col>
          <d-col
            v-if="data.scan_file.name !== ''"
            cols="12"
            md="6"
            lg="6">
            <label for="name">
              Skan dokumentów:
            </label>
            <validation-provider
              name="scan_file"
              v-slot="{ errors }">
              <file-input
                class="form-group"
                :onChange="setImage"
                :id="'scan_file'" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </d-col>
        </d-row>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!allDataLoaded"
        class="pb-3 pt-3 text-center overlay-loading">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'patients-form-medical-popup',
  props: {
    isVisible: {
      default: false,
      type: Boolean
    },
    medical: {
      default: null,
      type: Object
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patient: {
      required: true,
      type: Object
    },
    visitId: {
      defualt: 0,
      type: Number
    },
    allInstitutions: {
      required: true,
      type: Array
    },
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.medicalExaminationsLoaded;
    },
    isEdit () {
      return !!(this.medical && this.medical.id);
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue) {
        this.preparePopup();
        if (!this.medicalExaminationsLoaded || !this.medicalExaminations.length) {
          this.loadAdditionalData();
        }
      }
    }
  },
  data () {
    return {
      data: {
        id: 0,
        filename: '',
        medical_examination_id: null,
        patient_id: '',
        institution_id: null,
        scan_file: {
          filename: {},
          name: ''
        },
        short_description: '',
        visit_id: ''
      },
      loaded: false,
      medicalExaminations: [],
      medicalExaminationsLoaded: false
    };
  },
  mounted () {
  },
  methods: {
    preparePopup () {
      if (this.medical && this.medical.id) {
        Object.assign(this.data, this.medical);
      } else {
        this.data.id = 0;
        this.data.patient_id = this.patient.id;
        this.data.institution_id = null;
        this.data.filename = '';
        this.data.medical_examination_id = null;
        this.data.short_description = '';
        this.data.visit_id = '';
      }

      this.data.scan_file = {
        filename: {},
        name: ''
      }

      Vue.nextTick(() => {
        if (this.$refs['medical-examinations-patients-form']) {
          this.$refs['medical-examinations-patients-form'].reset();
        }

        this.loaded = true;
      })
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/medical-examinations/items',
        params: {
          pagination: false
        },
        outputKey: 'medicalExaminations',
        loadedKey: 'medicalExaminationsLoaded',
        errorKey: 'loadError'
      });
    },
    setImage(event) {
      this.data.scan_file.filename = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['medical-examinations-patients-form'], this.submitForm);
    },
    submitForm () {
      let imageFields = false;
      let formDataToSend = {
        patient_id: this.data.patient_id || this.patient.id,
        institution_id: this.data.institution_id,
        medical_examination_id: this.data.medical_examination_id,
        visit_id: this.visitId ? this.visitId : this.data.visit_id,
        short_description: this.data.short_description,
      };
      if (this.data.scan_file) {
        formDataToSend.filename = this.data.scan_file.filename;
        formDataToSend.name = this.data.scan_file.name;
        imageFields = ['filename'];
      }
      let endpointUrl = this.isEdit ? '/patients/medical-examinations/update/' + this.data.id : '/patients/medical-examinations/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano badanie',
        successText: 'Wybrane badanie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje badania nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    }
  }
};
</script>

<style lang="scss">
  @import '../../../assets/scss/variables/mixins';
  .popup-box-buttons {
    @include popupButtons
  }
  .popup-form .modal-dialog {
    margin-top: 5rem;
  }
  .invalid-data-filter {
    border: 1px solid #c4183c;
    border-radius: 5px;
  }
  .vs__dropdown-option {
    white-space: normal;
  }
</style>
